import Logo from './pictures/logo-2024.png';
import { FaClock, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { CiLinkedin } from 'react-icons/ci';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <section id="footer" className="text-white py-10 mt-10 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          
          {/* Logo e Linkedin */}
          <div
            className='flex flex-col items-center'
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <img src={Logo} alt="Logo Footer" className="w-44 mb-4" />
            <p className="text-gray-700 mb-2">Acompanhe nosso Linkedin</p>
            <a href="https://www.linkedin.com/company/28335031/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-blue-400">
              <CiLinkedin size={50} />
            </a>
          </div>

          {/* Navegação do site */}
          <div
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <h2 className="text-lg text-gray-700 font-semibold mb-4">Navegação do site</h2>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-700 no-underline hover:text-blue-400">Início</Link></li>
              <li><Link to="/sobre" className="text-gray-700 no-underline hover:text-blue-400">Sobre</Link></li>
              <li><Link to="/servicos" className="text-gray-700 no-underline hover:text-blue-400">Serviços</Link></li>
              <li><Link to="/projetos" className="text-gray-700 no-underline hover:text-blue-400">Projetos</Link></li>
              <li><Link to="/contato" className="text-gray-700 no-underline hover:text-blue-400">Contato</Link></li>
              <li><Link to="/trabalheconosco" className="text-gray-700 no-underline hover:text-blue-400">Trabalhe Conosco</Link></li>
            </ul>
          </div>

          {/* Serviços */}
          <div
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <h2 className="text-lg text-gray-700 font-semibold mb-4">Nossos serviços</h2>
            <ul className="space-y-2">
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Engenharia</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Construção e Manutenção Civil</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Apoio Geológico</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Facilities</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Topografia</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Manutenção de Telhados</Link></li>
              <li><Link to="#" className="text-gray-700 no-underline hover:text-blue-400 transition duration-500">Manutenção e Mecânica</Link></li>
            </ul>
          </div>

          {/* Contato */}
          <div
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <h2 className="text-lg text-gray-700 font-semibold mb-4">Informações e contatos</h2>
            <ul className="space-y-5 text-sm">
              <li className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 text-gray-700 " size={20} />
                <a href="https://goo.gl/maps/n7nbaKd2LzL6Kss38" className="text-gray-700 no-underline hover:text-blue-400">
                  Av. Tupinambá, 498 - Parque dos Carajás, Parauapebas - PA
                </a>
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className='text-gray-700' size={20} />
                <span className='text-gray-700'>(94) 3346-1014 / 3346-6200</span>
              </li>
              <li className="flex items-center gap-2">
                <FaEnvelope className='text-gray-700' size={20} />
                <a href="mailto:seculos@seculosengenharia.com.br" className="text-gray-700 no-underline hover:text-blue-400">
                  seculos@seculosengenharia.com.br
                </a>
              </li>
              <li className="flex items-center gap-2">
                <FaClock className='text-gray-700' size={20} />
                <span className='text-gray-700'>Segunda a Sexta: das 08h às 18h</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
